import React, { useEffect, useState } from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from 'bootstrap'
import styles from '../FAQ/style.module.css';

function FAQ(props) {
    var [toggle1, setToggle1] = useState(false);
    var [toggle2, setToggle2] = useState(false);
    var [toggle3, setToggle3] = useState(false);
    var [toggle4, setToggle4] = useState(false);
    var [toggle5, setToggle5] = useState(false);

    useEffect(() => {
        var faq1 = document.getElementById('faq1')
        var faq1Collapse = new Collapse(faq1, { toggle: false })
        toggle1 ? faq1Collapse.show() : faq1Collapse.hide()

        var faq2 = document.getElementById('faq2')
        var faq2Collapse = new Collapse(faq2, { toggle: false })
        toggle2 ? faq2Collapse.show() : faq2Collapse.hide()

        var faq3 = document.getElementById('faq3')
        var faq3Collapse = new Collapse(faq3, { toggle: false })
        toggle3 ? faq3Collapse.show() : faq3Collapse.hide()

        var faq4 = document.getElementById('faq4')
        var faq4Collapse = new Collapse(faq4, { toggle: false })
        toggle4 ? faq4Collapse.show() : faq4Collapse.hide()

        var faq5 = document.getElementById('faq5')
        var faq5Collapse = new Collapse(faq5, { toggle: false })
        toggle5 ? faq5Collapse.show() : faq5Collapse.hide()
    })

    return (
        <>
            <div className="offset-lg-1 col-lg-10 mb-5">
                <div style={{ fontSize: "25px", fontWeight: "bold" }} className="mb-3 text-center pt-3">Frequently Asked Questions</div>
                <div className="container">
                    <div className={styles.faqHeader}>
                        <div className="p-3" style={toggle1 ? { borderBottom: "1px solid grey", borderRadius: "5px" } : {}}>
                            <Row onClick={() => setToggle1(toggle => !toggle)}>
                                <Col style={{
                                    fontSize: 16,
                                    fontWeight: 600
                                }}>
                                    What kind of tasks can the attendant perform?
                                </Col>
                                <Col className='col-1 text-end'>
                                    {!toggle1 && <FontAwesomeIcon icon="plus" />}
                                    {toggle1 && <FontAwesomeIcon icon="minus" />}
                                </Col>
                            </Row>
                        </div>
                        <div className="collapse  p-3" id="faq1">
                            <div style={{ fontSize: "15px",textAlign:"justify" }}>
                                <p>The tasks of the attendant includes oral care, changing diapers, sponge bath, feeding assistance, bathroom assistance, walking and home exercise assistance, mobility in bed for bedridden patients, making patient’s bed, helping patient get into and out of the wheelchair, occasional light massage for 10 to 15 mins, vital monitoring, ensuring proper medication as directed by the doctor, keeping patient room clean and hygienic.</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.faqHeader}>
                        <div className="p-3" style={toggle2 ? { borderBottom: "1px solid grey", borderRadius: "5px" } : {}}>
                            <Row onClick={() => setToggle2(toggle => !toggle)}>
                                <Col style={{
                                    fontSize: 16,
                                    fontWeight: 600
                                }}>
                                    Can I have more than one attendant or nurse for the patient?
                                </Col>
                                <Col className='col-1 text-end'>
                                    {!toggle2 && <FontAwesomeIcon icon="plus" />}
                                    {toggle2 && <FontAwesomeIcon icon="minus" />}
                                </Col>
                            </Row>
                        </div>
                        <div className="collapse p-3" id="faq2">
                            <div style={{ fontSize: "15px",textAlign:"justify" }}>
                                <p>Definitely. Depending on the patient’s requirement you can book multiple attendants/nurses at additional charges.</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.faqHeader}>
                        <div className="p-3" style={toggle3 ? { borderBottom: "1px solid grey", borderRadius: "5px" } : {}}>
                            <Row onClick={() => setToggle3(toggle => !toggle)}>
                                <Col style={{
                                    fontSize: 16,
                                    fontWeight: 600
                                }}>
                                    Can caregivers help patients with special needs such as patients with Dementia?
                                </Col>
                                <Col className='col-1 text-end'>
                                    {!toggle3 && <FontAwesomeIcon icon="plus" />}
                                    {toggle3 && <FontAwesomeIcon icon="minus" />}
                                </Col>
                            </Row>
                        </div>
                        <div className="collapse p-3" id="faq3">
                            <div style={{ fontSize: "15px",textAlign:"justify" }}>
                                <p>Our attendants are medically trained and certified by our medical team so that they can perform different types of tasks required by patients with special needs. Our attendants assist the patient in their daily activities and tasks: dressing and grooming, oral feeding, administration of oral medications, and engaging them in memory exercises, meditation, and recommended therapies.</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.faqHeader}>
                        <div className="p-3" style={toggle4 ? { borderBottom: "1px solid grey", borderRadius: "5px" } : {}}>
                            <Row onClick={() => setToggle4(toggle => !toggle)}>
                                <Col style={{
                                    fontSize: 16,
                                    fontWeight: 600
                                }}>
                                    What steps does Care24 take to ensure the safety and security of the patient and their families?
                                </Col>
                                <Col className='col-1 text-end'>
                                    {!toggle4 && <FontAwesomeIcon icon="plus" />}
                                    {toggle4 && <FontAwesomeIcon icon="minus" />}
                                </Col>
                            </Row>
                        </div>
                        <div className="collapse p-3" id="faq4">
                            <div style={{ fontSize: "15px",textAlign:"justify" }}>
                                <p>All our attendants and nurses are verified by proper background checks including police verification. We also ensure they have taken double Covid-19 vaccinations.</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.faqHeader}>
                        <div className="p-3" style={toggle5 ? { borderBottom: "1px solid grey", borderRadius: "5px" } : {}}>
                            <Row onClick={() => setToggle5(toggle => !toggle)}>
                                <Col style={{
                                    fontSize: 16,
                                    fontWeight: 600
                                }}>
                                    Can the attendant help with other household chores?
                                </Col>
                                <Col className='col-1 text-end'>
                                    {!toggle5 && <FontAwesomeIcon icon="plus" />}
                                    {toggle5 && <FontAwesomeIcon icon="minus" />}
                                </Col>
                            </Row>
                        </div>
                        <div className="collapse p-3" id="faq5">
                            <div style={{ fontSize: "15px",textAlign:"justify" }}>
                                <p>No, attendants are required to assist only the patient in their day-to-day activities.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FAQ